import { inject, injectable } from 'inversify';
import ProductsRepository from 'src/features/products/data/ProductsRepository';

interface GetProductsByBrandUseCaseParams {
  storeSlug: string;
  brandSlug: string;
  limit?: number;
  offset?: number;
  token?: string;
}

@injectable()
class GetProductsByBrandUseCase {
  @inject(ProductsRepository) private productsRepository!: ProductsRepository;

  async execute(params: GetProductsByBrandUseCaseParams) {
    return await this.productsRepository.getStoreStock({
      ...params,
      product__brand__slug_name: params.brandSlug,
    });
  }
}

export default GetProductsByBrandUseCase;
